import React, { useState, Fragment } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { DataGrid, useGridApiRef } from '@mui/x-data-grid';
import estilos from './TablaProducto.module.css';
import { v4 as uuidv4 } from 'uuid';
import Box from '@mui/material/Box';
import Tooltip from '@mui/material/Tooltip';
import {
    Table,
    Button,
    Container,
    Modal,
    ModalHeader,
    ModalBody,
    FormGroup,
    ModalFooter,
} from "reactstrap";
import ModalCamposObligatorios from '../../../App/ModalCamposObligatorios'
function TablaResponsablesInstalaciones(props) {

    const { api = undefined } = props
    let fc_36PersonasAutorizadasMap = props.productosMap
    let otrainstalacion = props.propia
    let tipoInstalaciones = props.tipoInstalaciones
    let aliasInstalaciones = props.alias
    const emicioncertificadopromocion = props.emicioncertificadopromocion
    const { handdle, handdleRemovePrev, handdleEditPrev, responsableInst, handdleResponsableInstalacionBaja,
        /*handdleResponsableInstalacionAlta,*/ handdleResponsableInstalacionAlias } = api
    const [id, setId] = React.useState()

    const [tipoinstalacion, setTipoInstalacion] = React.useState('')
    const [alias, setAlias] = React.useState('')
    console.log("alias ", alias)
    const [responsableinstalacion, setresponsableinstalacion] = React.useState('')
    const [telefono, settelefono] = React.useState('')
    const [correoelectronico, setCorreo] = React.useState('')
    const [domicilio, setDomicilio] = React.useState('')
    const [editar, setEditar] = React.useState(false)

    const [productoMap, setproductoMap] = React.useState()

    const [validacion, setvalidacion] = React.useState(false)
    const [texto, settexto] = React.useState('')
    const resetValores = (objectProducto) => {
        setvalidacion(objectProducto.validacion)
    }
    let columns = [
        {
            field: 'tipoinstalacion', headerName: 'Instalación', headerClassName: estilos.headerSolicitudes, headerAlign: 'center', flex: .5,
            renderCell: (params) =>
            (
                <div>
                    <Tooltip title={`${params.row.tipoinstalacion}`} arrow>
                        <label>{`${params.row.tipoinstalacion} `}</label>
                    </Tooltip>
                </div>
            )
        },
        {
            field: 'alias', headerName: 'Alias de la instalacion', headerClassName: estilos.headerSolicitudes, headerAlign: 'center', flex: 1,
            renderCell: (params) =>
            (
                <div>
                    <Tooltip title={`${params.row.alias}`} arrow>
                        <label>{`${params.row.alias} `}</label>
                    </Tooltip>
                </div>
            )
        },
        {
            field: 'responsableinstalacion', headerName: 'Responsable de instalación', headerClassName: estilos.headerSolicitudes, headerAlign: 'center', flex: .7,
            renderCell: (params) =>
            (
                <div>
                    <Tooltip title={`${params.row.responsableinstalacion}`} arrow>
                        <label>{`${params.row.responsableinstalacion} `}</label>
                    </Tooltip>
                </div>
            )
        },
        {
            field: 'telefono', headerName: 'Teléfono', headerClassName: estilos.headerSolicitudes, headerAlign: 'center', flex: .6,
            renderCell: (params) =>
            (
                <div>
                    <Tooltip title={`${params.row.telefono}`} arrow>
                        <label>{`${params.row.telefono} `}</label>
                    </Tooltip>
                </div>
            )
        },
        {
            field: 'correoelectronico', headerName: 'Correo Electrónico', headerClassName: estilos.headerSolicitudes, headerAlign: 'center', flex: .6,
            renderCell: (params) =>
            (
                <div>
                    <Tooltip title={`${params.row.correoelectronico}`} arrow>
                        <label>{`${params.row.correoelectronico} `}</label>
                    </Tooltip>
                </div>
            )
        },
        {
            field: 'accion', headerName: 'Acción', headerClassName: estilos.headerSolicitudes, headerAlign: 'center', flex: .4,
            renderCell: (params) => (

                <Fragment>
                    {params.row.baja === null ?
                        <Fragment>

                            {fc_36PersonasAutorizadasMap?.length > 0 ? (
                                <Fragment>
                                    <button className={'btn btn-danger ms-1'} onClick={() => { botonCorregir(params) }} >Corregir</button>
                                </Fragment>
                            ) : (
                                <Fragment>
                                    <button className={'btn btn-warning ms-0'} onClick={() => { botonEditar(params) }}>Editar</button>
                                    <button className={'btn btn-danger ms-1'} onClick={() => { botonEliminar(params) }} >Eliminar</button>
                                </Fragment>)}
                        </Fragment>
                        : ((params.row.baja === false || params.row.baja === true) && params.row.isbaja === false) ?
                            <Fragment>
                                <button className={params.row.baja === false ? `btn btn-outline-warning ms-1` : params.row.baja === true ? `btn btn-danger ms-1` : ''} onClick={() => { botonBaja(params.row) }} >Dar de Baja</button>
                            </Fragment> :
                            <Fragment>
                                {/*<button className={(params.row.baja === false && params.row.alta === false) ? `btn btn-outline-warning ms-1` : (params.row.baja === false && params.row.alta === true) ? `btn btn-success ms-1` : ''} onClick={() => { botonAlta(params.row) }} >Dar de Alta</button>*/}
                            </Fragment>
                    }
                </Fragment>

            )
        },
    ]

    const botonEliminar = async (params) => {
        handdleRemovePrev({ data: params.row })
    }

    const botonGuardar = async () => {
        if (telefono.toString().length > 0 && correoelectronico.length > 0 && responsableinstalacion.length > 0 && tipoinstalacion !== '' && tipoinstalacion != '0' &&
            alias != '' && alias != '0') {
            let cortar = alias.split('/')
            let aliasC = cortar[0]
            let domicilioC = cortar[1]
            let dato = {
                id: id, tipoinstalacion: tipoinstalacion, alias: aliasC, responsableinstalacion: responsableinstalacion, telefono: telefono,
                correoelectronico: correoelectronico, isbaja: false, alta: true, baja: null, domicilio: domicilioC
            }
            handdleEditPrev(dato)
            setTipoInstalacion('')
            setAlias('')
            setresponsableinstalacion('')
            settelefono('')
            setCorreo('')
            setEditar(false)
            setproductoMap([])
        }
    }
    const botonEditar = async (params) => {
        setId(params.row.id)
        setTipoInstalacion(params.row.tipoinstalacion)
        filtroAlias(params.row.tipoinstalacion)
        setAlias(params.row.alias + '/' + params.row.domicilio)
        setresponsableinstalacion(params.row.responsableinstalacion)
        settelefono(params.row.telefono)
        setCorreo(params.row.correoelectronico)
        setEditar(true)
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        })
    }

    let datos = []
    let [rows, setRows] = React.useState(responsableInst)
    React.useEffect(() => {
        setRows(responsableInst)
    }, [responsableInst])

    const botonAgregar = async () => {
        if (telefono.toString().length > 0 && correoelectronico.length > 0 && responsableinstalacion.length > 0 && tipoinstalacion !== '' && tipoinstalacion != '0' &&
            alias != '' && alias != '0') {
            let cortar = alias.split('/')
            let aliasC = cortar[0]
            let domicilioC = cortar[1]
            let dato = {
                id: uuidv4(), tipoinstalacion: tipoinstalacion, alias: aliasC, responsableinstalacion: responsableinstalacion, telefono: telefono,
                correoelectronico: correoelectronico, alta: true, baja: null, isbaja: false, domicilio: domicilioC
            }
            handdle(dato)
            setTipoInstalacion('')
            setAlias('')
            setresponsableinstalacion('')
            settelefono('')
            setCorreo('')
            setEditar(false)
        } else {
            setvalidacion(true)
        }
    }
    const botonCancelar = async () => {
        setproductoMap([])
        setresponsableinstalacion('')
        settelefono('')
        setCorreo('')
        setAlias('')
        setTipoInstalacion('')
        setEditar(false)
    }
    const botonCorregir = async (params) => {
        const filtro = fc_36PersonasAutorizadasMap.filter(anexo => anexo?.idfc_36_actulizarresponsableinstalaciones === params.row.idfc_36_actulizarresponsableinstalaciones)
        setproductoMap(filtro[0])
        if (params.row.idfc_36_actulizarresponsableinstalaciones) setId(params.row.idfc_36_actulizarresponsableinstalaciones)
        else setId(params.row.idfc_36_actulizarresponsableinstalaciones)
        setTipoInstalacion(params.row.tipoinstalacion)
        filtroAlias(params.row.tipoinstalacion)
        setAlias(params.row.alias + '/' + params?.row?.domicilio)
        setresponsableinstalacion(params.row.responsableinstalacion)
        settelefono(params.row.telefono)
        setCorreo(params.row.correoelectronico)
        setEditar(true)
    }
    const botonBaja = async (params) => {
        handdleResponsableInstalacionBaja(params)
        //alert("se cambia")
    }
    /*const botonAlta = async (params) => {
        handdleResponsableInstalacionAlta(params)
    }*/
    const filtroAlias = async (params) => {
        handdleResponsableInstalacionAlias(params)
    }
    return (
        <>
            <FormGroup>
                <div className='row align-items-center'>
                    <div className='col-md-6'>
                        <div className="form-floating mb-3">
                            <select className={`form-select form-select-sm ${productoMap?.validacioncheck !== undefined ? (
                                productoMap?.validacioncheck ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                value={tipoinstalacion} onChange={e => (
                                    setTipoInstalacion(e.target.value),
                                    filtroAlias(e.target.value), setAlias("0"))} >
                                <option value="0">Seleccione una opcion</option>
                                {tipoInstalaciones?.map((opcion, i) => (
                                    <option value={`${opcion.idtipoanexo === 1 ? 'Unidad de Produccion' : opcion.idtipoanexo === 2 ? 'Unidad de Envasado' : 'Unidad de Almacen'}`} >
                                        {`${opcion.idtipoanexo === 1 ? 'Unidad de Producción' : opcion.idtipoanexo === 2 ? 'Unidad de Envasado' : 'Unidad de Almacen'}`}</option>
                                ))}
                            </select>
                            {(tipoinstalacion == '' || tipoinstalacion == '0') ? <>
                                <span className='text-danger'>Campo obligatorio</span><br /></> : ''}
                            <span className='text-danger'>{productoMap?.validacioncheck}</span>
                        </div>
                    </div>
                    <div className='col-md-6'>
                        <div className="form-floating mb-3">
                            <select className={`form-select form-select-sm ${productoMap?.validacioncheck !== undefined ? (
                                productoMap?.validacioncheck ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                value={alias} onChange={e => setAlias(e.target.value)} >
                                <option value="0">Seleccione el alias</option>
                                {aliasInstalaciones?.map((opcion, i) => (
                                    <option value={`${opcion.alias + '/' + opcion?.calle + ', ' + opcion?.numerointerior + ', ' +
                                        opcion?.numeroexterior + ', ' + opcion?.colonia + ', ' + opcion?.localidad + ', ' +
                                        opcion?.municipio + ', ' + opcion?.estado + ', ' + opcion?.codigopostal}`} >
                                        {`${opcion.alias + ': ' + opcion?.calle + ', ' + opcion?.numerointerior + ', ' +
                                            opcion?.numeroexterior + ', ' + opcion?.colonia + ', ' + opcion?.localidad + ', ' +
                                            opcion?.municipio + ', ' + opcion?.estado + ', ' + opcion?.codigopostal}`}</option>
                                ))}
                            </select>
                            {(alias == '' || alias == '0') ? <>
                                <span className='text-danger'>Campo obligatorio</span><br /></> : ''}
                            <span className='text-danger'>{productoMap?.validacioncheck}</span>
                        </div>
                    </div>
                    <div className='col-md-4 mt-2'>
                        <div className="form-floating mb-3">
                            <input type="text" className={`form-control ${productoMap?.validacioncheck !== undefined ? (productoMap?.validacioncheck
                                ? 'inputDenegado' : 'inputValidado') : ('')}`} id="floatingInput" placeholder='volumen'
                                value={responsableinstalacion} onChange={e => setresponsableinstalacion(e.target.value)}
                            />
                            <label htmlFor='floatingInput'>Nombre completo</label>

                            {responsableinstalacion.length <= 0 ? <>
                                <span className='text-danger'>Campo obligatorio</span><br /></> : ''}
                            <span className='text-danger'>{productoMap?.validacioncheck ? productoMap?.observacion : ''}</span>
                        </div>
                    </div>
                    <div className='col-md-4 mt-2'>
                        <div className="form-floating mb-3">
                            <input type="number" min='0' className={`form-control ${productoMap?.validacioncheck !== undefined ? (productoMap?.validacioncheck
                                ? 'inputDenegado' : 'inputValidado') : ('')}`} id="floatingInput" placeholder='No. de cajas'
                                value={telefono} onChange={e => settelefono(e.target.value)}
                            />
                            <label htmlFor='floatingInput'>Teléfono</label>
                            {telefono.length <= 0 ? <>
                                <span className='text-danger'>Campo obligatorio</span> <br /></> : ''}
                            <span className='text-danger'>{productoMap?.validacioncheck ? productoMap?.observacion : ''}</span>
                        </div>
                    </div>
                    <div className='col-md-4 mt-2'>
                        <div className="form-floating mb-3">
                            <input type="text" className={`form-control ${productoMap?.validacioncheck !== undefined ? (productoMap?.validacioncheck
                                ? 'inputDenegado' : 'inputValidado') : ('')}`} id="floatingInput" placeholder='volumen'
                                value={correoelectronico} onChange={e => setCorreo(e.target.value)}
                            />
                            <label htmlFor='floatingInput'>Correo Eletrónico</label>

                            {correoelectronico.length <= 0 ? <>
                                <span className='text-danger'>Campo obligatorio</span><br /></> : ''}
                            <span className='text-danger'>{productoMap?.validacioncheck ? productoMap?.observacion : ''}</span>
                        </div>
                    </div>
                </div>
            </FormGroup>
            {
                !editar ?
                    <Fragment>
                        {fc_36PersonasAutorizadasMap?.length === 0 ? (
                            <Fragment>
                                <div className='col-md-3'></div>
                                <div className='text-center'>
                                    <button className='btn btn-success col-md-4' onClick={botonAgregar}>Agregar responsable de instalacion</button>
                                </div>
                                <br />
                            </Fragment>) : ''}
                    </Fragment>
                    : (
                        <Fragment>
                            <div className='row'>
                                <div className='col-md-3'></div>
                                <button className={'btn btn-success col-md-4 ms-0'} onClick={botonGuardar}>Guardar responsable de instalación</button>
                                <button className={'btn btn-dark col-md-3 ms-2'} onClick={botonCancelar}>Cancelar</button>
                            </div>
                            <br />
                        </Fragment>
                    )
            }
            <br />
            <hr />
            {validacion && <ModalCamposObligatorios texto={texto} api={{ resetValores }}></ModalCamposObligatorios>}
            <div className='row justify-content-center'>

                <div className='col-12'><br />
                    <div style={{ height: (130 + (rows?.length * 50)), width: '107%', color: 'black', marginLeft: '-5%' }}>
                        <DataGrid
                            rows={rows}
                            columns={columns}
                            //checkboxSelection={true}
                            //disableSelectionOnClick
                            /*onSelectionModelChange={(id) => {
                                idsParaAsignar = id
                            }}*/
                            sx={{
                                boxShadow: 0,
                                color: 'black',
                                border: 0,
                                '& .MuiDataGrid-cell': {
                                    display: 'block',
                                    position: 'relative',
                                    textAlign: 'center',
                                },
                            }}
                        />

                    </div><br />
                </div>
            </div>

        </>
    )

}
export default TablaResponsablesInstalaciones